<template>
    <component :is="layout">
        <h1 @click="reduceClicks"> 404 </h1>
        <h3> Страница не найдена </h3>
        <span @click="toggleRightSidebarState" class="err404"> Сообщить об ошибке</span>
        <div v-if="isItZero"> <router-link :to="{name: 'forMisha'}"> Мишина Гордость </router-link> </div>

    </component>
</template>

<script>
export default {
  name: "err404",
  data() {
    return {
      layout: 'default-layout',
      clicks: 8,
    }
  },
  computed: {
    isItZero() {
      return this.clicks <= 0
    }
  },
  methods: {
    toggleRightSidebarState() {
      this.$store.commit('toggleSidebarState')
    },
    reduceClicks() {
      this.clicks -= 1
    }
  }
};
</script>

<style lang="sass" scoped>
    .err404
        &:hover
            cursor: pointer
            text-decoration: underline
</style>
